module.exports = __webpack_public_path__ + "static/media/login.68163ab3.svg";